import { actions } from 'react/api/actions/survey';
import { fromJS } from 'immutable';

const initialState = fromJS({
  sections: {
    applicationRules: {
      modalIsOpen: false,
      ruleData: {}
    }
  },
});

export default (state = initialState, action) => {
  let newState = state;
  switch(action.type) {
    case actions.toggleApplicationRulesModal:
      const modalIsOpen = state.getIn(['sections', 'applicationRules', 'modalIsOpen']);
      newState = newState.setIn(['sections', 'applicationRules', 'ruleData'], fromJS({}));
      newState = newState.mergeIn(['sections', 'applicationRules', 'modalIsOpen'], !modalIsOpen);
      return newState;
    case actions.openApplicationRulesModal:
      newState = newState.mergeIn(['sections', 'applicationRules', 'modalIsOpen'], true);
      newState = newState.mergeIn(['sections', 'applicationRules', 'ruleData'], action.payload.ruleData);
      return newState;
    default:
      return state;
  }
};
